module.exports = __webpack_public_path__ + "img/027_thumbnail.eee3431b.jpg";